export enum Device {
  DESKTOP = 'desktop',
  PHONE = 'phone',
}

export enum Widget {
  FEEDBACK = 'feedback',
  SURVEY = 'survey',
}

export type SurveyDisplayType = 'popover' | 'full_screen' | 'external_link';

export type FeedbackDisplayType = 'button' | 'inline';
